// Get currency format
const bodycuttency = document.getElementsByTagName("body")[0];
const currencySymbol = bodycuttency.getAttribute("currency-format");

// Function to cart drawer close button
function initializeCloseButton() {
  const closeButtons = document.querySelectorAll(".cls-btn");
  const cartSidebar = document.querySelector(".cart-sidebar");
  const overlay = document.querySelector(".fusion-overlay-custom");

  // Close button functionality
  for (var i = 0; i < closeButtons.length; i++) {
    closeButtons[i].addEventListener("click", function (e) {
      e.preventDefault();
      closeSidebar();
    });
  }

  // Click outside sidebar or on overlay to close
  document.addEventListener("click", function (e) {
    // Check if search popup is active - don't interfere with it
    const searchPopup =
      document.querySelector(".fusion-search-popup") ||
      document.querySelector(".dropdown-menu.fusion-search-popup");
    const isSearchPopupActive =
      searchPopup &&
      (searchPopup.classList.contains("active") ||
        searchPopup.classList.contains("show"));
    const isClickInsideSearchPopup =
      searchPopup && searchPopup.contains(e.target);

    // Don't close cart sidebar if search popup is active
    if (isSearchPopupActive && isClickInsideSearchPopup) {
      return;
    }

    var isClickInsideSidebar = cartSidebar && cartSidebar.contains(e.target);
    var isClickOnOverlay = overlay && overlay.contains(e.target);
    if (!isClickInsideSidebar || isClickOnOverlay) {
      closeSidebar();
    }
  });

  // Remove cartSidebar and body clases
  function closeSidebar() {
    if (cartSidebar) cartSidebar.classList.remove("active");
    if (overlay) overlay.classList.remove("overlay-active");

    document.body.classList.remove("overflow-hidden");
    document.body.classList.remove("z-index");
  }
}

// Function to initialize cart drawer product slider
function cartMayLikeProduct() {
  var cartMayLikeContainers = document.getElementsByClassName(
    "cart-may-like-product",
  );

  if (cartMayLikeContainers.length > 0) {
    for (var i = 0; i < cartMayLikeContainers.length; i++) {
      // Initialize Swiper for each slider found
      new Swiper(".cart-may-like-product-slider", {
        slidesPerView: 2,
        spaceBetween: 20,
        loop: true,
        speed: 1000,
        navigation: {
          nextEl: ".cart-swiper-button-next",
          prevEl: ".cart-swiper-button-prev",
        },
      });
    }
  }
}
cartMayLikeProduct();

// Function to redirect to checkout page
function productCheckoutPage() {
  var checkoutButton = document.getElementById("pop-cart-product-check-out");

  if (checkoutButton !== null) {
    checkoutButton.addEventListener("click", function () {
      window.location.replace("/checkout");
    });
  }
}
productCheckoutPage();

// Updated cart drawer content
function updateCartDrawer() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const count = cart.item_count;

      // Update all data-cart-item elements
      document.querySelectorAll("[data-cart-item]").forEach((el) => {
        el.setAttribute("data-cart-item", count);
        el.classList.toggle("has-items", count > 0);
      });

      // Update badge number
      const badge = document.querySelector(".cart-btn-num");
      if (badge) {
        let countSpan = badge.querySelector(".cart-count");

        if (!countSpan) {
          countSpan = document.createElement("span");
          countSpan.className = "cart-count";
        }

        countSpan.textContent = count > 0 ? count : "";
      }

      const currentDrawer = document.querySelector(
        ".cart-sidebar-title-count.cart-btn",
      );
      if (currentDrawer) {
        currentDrawer.dataset.cartItem = count;
        currentDrawer.textContent = count;
      }

      // Update cart drawer content
      fetch(window.location.pathname)
        .then((r) => r.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const newDrawer = doc.querySelector("#cart_drawer");
          const currentDrawerWrap = document.querySelector("#cart_drawer");

          if (newDrawer && currentDrawerWrap) {
            currentDrawerWrap.innerHTML = newDrawer.innerHTML;
            if (typeof initCountryProvinceSelector === "function") {
              initShippingEstimate();
            }
            if (typeof initCountryProvinceSelector === "function") {
              initCountryProvinceSelector();
            }

            initializeCloseButton();
            cartMayLikeProduct();
            productCheckoutPage();
          }
        })
        .catch((err) => console.error("Drawer fetch error:", err));
    })
    .catch((err) => console.error("Cart JSON error:", err));
}

// Updated cart drawer content end
document.addEventListener("DOMContentLoaded", function () {
  /* ---------- CONFIG ---------- */
  const filter4Selector = ".product-grid-filter .product_grid_filter_4_item";
  const filter3Selector = ".product-grid-filter .product_grid_filter_3_item";
  const storageKey = "productGridLayout"; // for saving user preference

  /* ---------- EVENT DELEGATION ---------- */
  document.addEventListener("click", function (e) {
    const filter4 = e.target.closest(filter4Selector);
    const filter3 = e.target.closest(filter3Selector);

    if (filter4) {
      e.preventDefault();
      applyGridLayout(4, filter4);
      localStorage.setItem(storageKey, "4"); // save selection
    } else if (filter3) {
      e.preventDefault();
      applyGridLayout(3, filter3);
      localStorage.setItem(storageKey, "3"); // save selection
    }
  });

  /* ---------- CORE LOGIC ---------- */
  function applyGridLayout(columns, triggerEl) {
    // 1. Clear all existing classes
    document.querySelectorAll("div[coln_page_attr]").forEach(function (el) {
      el.className = "";
    });

    // 2. Apply grid classes
    const gridClasses =
      columns === 4
        ? "coln_page_product col-6 col-sm-4 col-md-3 col-lg-3 visible"
        : "coln_page_product col-6 col-sm-4 col-md-4 col-lg-4 visible";

    document
      .querySelectorAll(".coln_page_products div[coln_page_attr]")
      .forEach(function (el) {
        el.className = gridClasses;
      });

    // 3. Update active button
    document
      .querySelectorAll(".product-grid-filter .product-grid-filter-item")
      .forEach(function (btn) {
        btn.classList.remove("active");
      });
    triggerEl.classList.add("active");
  }

  /* ---------- ON PAGE LOAD ---------- */
  const savedLayout = localStorage.getItem(storageKey);
  if (savedLayout === "3") {
    const savedBtn = document.querySelector(filter3Selector);
    if (savedBtn) applyGridLayout(3, savedBtn);
  } else {
    // Default: 4-column layout
    const defaultBtn = document.querySelector(filter4Selector);
    if (defaultBtn) applyGridLayout(4, defaultBtn);
  }
});

// Product Popup check-out
document.addEventListener("DOMContentLoaded", function () {
  var checkoutButtons = document.getElementsByClassName(
    "cart-product-check-out",
  );
  for (var i = 0; i < checkoutButtons.length; i++) {
    checkoutButtons[i].addEventListener("click", function () {
      var productForm = this.closest(".product_form_cart");
      if (!productForm) return;
      var formData = new FormData(productForm);
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then(function () {
          window.location.href = "/checkout";
        })
        .catch(function (error) {
          console.error("Cart add failed:", error);
        });
    });
  }
});

/* -----------------------------------------------------
   UTILITY:  addEventDelegated()
   ----------------------------------------------------- */
function addEventDelegated(eventType, selector, handler) {
  document.addEventListener(eventType, function (e) {
    const target = e.target.closest(selector);
    if (target) handler.call(target, e);
  });
}

/* -----------------------------------------------------
   1.  ADD‑TO‑CART FORM
   ----------------------------------------------------- */
addEventDelegated("submit", ".product_form_cart", function (event) {
  // If this form is inside a <product-form> custom element,
  // let product-form.js handle the submission to avoid double-adding.
  if (this.closest("product-form")) {
    return;
  }

  event.preventDefault();

  const form = this; // <form>
  const loader = form.querySelector(".custom-loading-spinner");
  const productItem = form.closest(".fusion-product-item");
  const qtySpan = productItem
    ? productItem.querySelector(".product_quantity_availability span")
    : null;

  /* Show loader */
  if (loader) loader.style.display = "block";

  /* Prepare form‑data (≈ jQuery .serialize()) */
  const formData = new FormData(form);

  /* POST to Shopify AJAX cart */
  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
    headers: { Accept: "application/json" },
  })
    .then((res) => {
      if (!res.ok) throw res;
      return res.json();
    })
    .then(() => {
      /* ---- SUCCESS ---- */

      if (qtySpan) qtySpan.textContent = "";
      if (loader) loader.innerHTML = '<div class="checkmark">✔</div>';

      setTimeout(() => {
        const cartBtn = document.querySelector(".cart-btn");
        if (cartBtn) cartBtn.click(); // open drawer
        if (typeof updateCartDrawer === "function") updateCartDrawer();

        /* reset loader */
        if (loader) {
          loader.style.display = "none";
          loader.innerHTML = '<div class="spinner"></div>';
        }
      }, 1500);
    })
    .catch(async (errResp) => {
      /* ---- ERROR ---- */
      if (qtySpan) {
        try {
          const errJson = await errResp.json();
          qtySpan.textContent = errJson.message || "Error adding item";
        } catch {
          qtySpan.textContent = "Error adding item";
        }
        if (qtyWrapper) {
          qtyWrapper.classList.remove("d-none");
        }
      }
      if (loader) loader.style.display = "none";
      console.error("Cart add failed:", errResp);
    });
});

/* -----------------------------------------------------
   2.  VARIANT‑PRICE HANDLING
   ----------------------------------------------------- */
/* Helpers remain unchanged */
function findValue(product, value) {
  const target = value.toLowerCase();

  return (
    product.variants.find(
      (v) =>
        v.title.toLowerCase() === target ||
        v.option1?.toLowerCase() === target ||
        v.option2?.toLowerCase() === target ||
        v.option3?.toLowerCase() === target,
    ) || null
  );
}
function findValuesWithAnd(product, values) {
  const lowerVals = values.map((v) => v.toLowerCase());

  return (
    product.variants.find((variant) => {
      const opts = [
        variant.option1?.toLowerCase(),
        variant.option2?.toLowerCase(),
        variant.option3?.toLowerCase(),
      ].filter(Boolean);

      return lowerVals.every((v) => opts.includes(v));
    }) || null
  );
}

/* Build the variant key (title / colour) */
function buildVariantKey(target) {
  const product = target.closest(".coln_page_product");

  // Get the DESIGN group (first title-select-form after "design")
  const designForm = product.querySelector(
    ".product-qty-title:nth-of-type(1) + form",
  );

  // Get the SIZE group (second title-select-form after "size")
  const sizeForm = product.querySelector(
    ".product-qty-title:nth-of-type(2) + form",
  );

  const designChecked = designForm?.querySelector(
    'input[type="radio"]:checked',
  );
  const sizeChecked = sizeForm?.querySelector('input[type="radio"]:checked');

  const designValue = designChecked
    ? designChecked.closest("li").dataset.size
    : null;
  const sizeValue = sizeChecked ? sizeChecked.closest("li").dataset.size : null;

  if (designValue && sizeValue) return [designValue, sizeValue];
  if (designValue) return designValue;
  if (sizeValue) return sizeValue;

  return null;
}

/* Listen for radio‑button changes */
addEventDelegated(
  "change",
  '.title-select-form input[type="radio"], .color-select-form input[type="radio"]',
  function () {
    if (this.closest("fuzion-variant-options")) return;
    const productItem = this.closest(".fusion-product-item");
    if (!productItem) return;

    const handle = productItem.getAttribute("product-hand-id");
    const variantKey = buildVariantKey(this);

    if (!variantKey) {
      console.warn("No variant selected for", handle);
      return;
    }
    fetchProductData(handle, variantKey, this);
  },
);

/* Fetch product JSON & update DOM */

function fetchProductData(handle, key, triggerEl) {
  if (!handle) return;

  fetch(`/products/${handle}.js`)
    .then((r) => r.json())
    .then((product) => {
      const variant = Array.isArray(key)
        ? findValuesWithAnd(product, key)
        : findValue(product, key);
      const container = triggerEl.closest(".fusion-product-item");
      const priceEl = container.querySelector(".current-price");
      const compareEl = container.querySelector(".compare_at_price");
      const hiddenInput = triggerEl
        .closest(".variantgetid_content")
        ?.querySelector('input[name="id"]');
      const addToCartBtn = container.querySelector("#product_detail_add-cart");
      if (!variant) {
        addToCartBtn.setAttribute("disabled", "disabled");
        addToCartBtn.innerHTML =
          window.variantStrings.unavailable || "Unavailable";
        return;
      }
      // --- Update Price ---
      if (priceEl && variant.price != null) {
        priceEl.textContent = `${currencySymbol} ${(variant.price / 100).toFixed(2)}`;
      }
      if (compareEl && variant.compare_at_price != null) {
        compareEl.textContent = `${currencySymbol} ${(variant.compare_at_price / 100).toFixed(2)}`;
      }

      // --- Update Hidden Input (variant ID) ---
      if (hiddenInput) hiddenInput.value = variant.id;

      // --- Update Pickup Availability ---
      const pickupAvailabilityEl = document.querySelector(
        "pickup-availability",
      );
      if (pickupAvailabilityEl) {
        pickupAvailabilityEl.dataset.variantId = variant.id;
        if (typeof pickupAvailabilityEl.update === "function") {
          pickupAvailabilityEl.update(variant);
        }
      }
      if (addToCartBtn) {
        if (!variant.available) {
          addToCartBtn.setAttribute("disabled", "disabled");
          addToCartBtn.innerHTML = window.variantStrings.soldOut || "Sold out";
        } else {
          addToCartBtn.removeAttribute("disabled");
          addToCartBtn.innerHTML = `
            ${Shopify.translation?.products?.product?.add_to_cart || "Add to Cart"}
            <div class="custom-loading-spinner" style="display: none;">
              <div class="spinner"></div>
            </div>
          `;
        }
      }
    })
    .catch((err) => console.error("Variant fetch failed:", err));
}

/* -----------------------------------------------------
   3.  QUANTITY HELPERS
   ----------------------------------------------------- */
function changeQuantity(delta, button) {
  const wrap = button.closest(".product_inner_variant");
  if (!wrap) return;

  const qtyIn = wrap.querySelector(".product-quantity-input");
  // Hidden quantity input may not exist on all templates; fall back to any quantity field
  const hidIn =
    wrap.querySelector(".quantity") ||
    wrap.querySelector('input[name="quantity"]');

  let currentVal = qtyIn && qtyIn.value ? qtyIn.value : "1";
  let qty = parseInt(currentVal, 10) + delta;
  if (qty < 1) qty = 1;
  if (qtyIn) qtyIn.value = qty;
  if (hidIn) hidIn.value = qty;
}
function updateQuantity(input) {
  const wrap = input.closest(".product");
  const qtyIn = wrap.querySelector(".product-quantity-input");
  const hidIn = wrap.querySelector(".quantity");
  let qty = parseInt(qtyIn.value || "1", 10);
  if (isNaN(qty) || qty < 1) qty = 1;
  qtyIn.value = qty;
  hidIn.value = qty;
}

/* -----------------------------------------------------
   4.  debounce()
   ----------------------------------------------------- */
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key

    // Check if the focused element is within the container
    if (!container.contains(event.target)) return;

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };
  // Add the keydown listener immediately when trapFocus is called
  document.addEventListener("keydown", trapFocusHandlers.keydown);
  elementToFocus.focus();
  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}
